import { render } from "./TenantCompanyModal.vue?vue&type=template&id=73c6a79a"
import script from "./TenantCompanyModal.vue?vue&type=script&lang=js"
export * from "./TenantCompanyModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__